/*
 * <healr-marquee> — seamless infinite ticker.
 * Clones its single [data-marquee-group] until it fills the track, then
 * animates a constant-speed horizontal scroll. Reimplemented natively
 * (no Timeline / react-fast-marquee bundle).
 *
 * Attributes:
 *   data-speed      px per second (default 60)
 *   data-direction  "left" | "right" (default left)
 *   data-pause-hover "true" | "false"
 */
(function () {
  if (customElements.get('healr-marquee')) return;

  customElements.define(
    'healr-marquee',
    class HealrMarquee extends HTMLElement {
      connectedCallback() {
        // Custom elements are display:inline by default, which prevents
        // overflow:hidden from clipping the wide track (causes page-wide
        // horizontal scroll). Force a block box so clipping works.
        if (!this.style.display) this.style.display = 'block';

        this.track = this.querySelector('[data-marquee-track]');
        this.group = this.querySelector('[data-marquee-group]');
        if (!this.track || !this.group) return;

        this.speed = parseFloat(this.dataset.speed) || 60;
        this.direction = this.dataset.direction === 'right' ? 'right' : 'left';

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.build();

        if (this.dataset.pauseHover === 'true') {
          this.addEventListener('mouseenter', () => {
            this.track.style.animationPlayState = 'paused';
          });
          this.addEventListener('mouseleave', () => {
            this.track.style.animationPlayState = 'running';
          });
        }

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.build());
          this.ro.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
      }

      build() {
        // Reset to a single group before measuring.
        const clones = this.track.querySelectorAll('[data-marquee-clone]');
        clones.forEach((c) => c.remove());

        const groupWidth = this.group.scrollWidth;
        if (!groupWidth) return;

        const containerWidth = this.offsetWidth;
        // Need enough copies so the strip is at least 2x the container wide.
        const copiesNeeded = Math.max(1, Math.ceil((containerWidth * 2) / groupWidth));

        for (let i = 0; i < copiesNeeded; i++) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('data-marquee-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        }

        const duration = groupWidth / this.speed;
        this.track.style.setProperty('--marquee-shift', groupWidth + 'px');
        this.track.style.animationDuration = duration + 's';
        this.track.style.animationDirection = this.direction === 'right' ? 'reverse' : 'normal';
      }
    }
  );
})();
